(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.luxury-collection').forEach((section) => {

    const sizeChips = [...section.querySelectorAll('[data-size-filter]')];
    const accessoryChips = [...section.querySelectorAll('[data-accessory-filter]')];
    const chips = [...sizeChips, ...accessoryChips];
    const cards = [...section.querySelectorAll('.luxury-rug-card[data-product-title]')];
    const selects = [...section.querySelectorAll('[data-filter-select]')];
    const searchInput = section.querySelector('[data-filter-search]');
    const visibleCount = section.querySelector('[data-visible-count]');
    if (!chips.length || !cards.length) return;

    const activeFilters = {
      size: 'all',
      accessory: 'all',
      collection: 'all',
      search: ''
    };

    const rugTargets = [
      { label: '1 x 1.5 m', width: 1.0, height: 1.5 },
      { label: '1.2 x 1.8 m', width: 1.2, height: 1.8 },
      { label: '2 x 1.5 m', width: 2.0, height: 1.5 },
      { label: '1.7 x 2.4 m', width: 1.7, height: 2.4 },
      { label: '2 x 3 m', width: 2.0, height: 3.0 },
      { label: '2.5 x 3.5 m', width: 2.5, height: 3.5 },
      { label: '3 x 4 m', width: 3.0, height: 4.0 }
    ];
    const runnerTargets = [
      { label: '< 2 m', length: 1.9 },
      { label: '3 m', length: 3.0 },
      { label: '4 m', length: 4.0 },
      { label: '5 m+', length: 5.0 }
    ];
    const targets = section.dataset.collectionHandle === 'runners' ? runnerTargets : rugTargets;

    const normalize = (value) => (value || '').trim().toLowerCase();
    const normalizeSearchText = (value) => normalize(value).replace(
      /(\d+(?:[.,]\d+)?)\s*(cm|mm|m)?\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm|m)?\b/gi,
      (_match, firstValue, firstUnit, secondValue, secondUnit) => {
        const toMetres = (number, unit) => Number(number.replace(',', '.')) / ({ cm: 100, mm: 1000 }[normalize(unit)] || 1);
        const first = toMetres(firstValue, firstUnit || secondUnit);
        const second = toMetres(secondValue, secondUnit || firstUnit);
        if (![first, second].every((number) => Number.isFinite(number) && number > 0)) return _match;
        const format = (number) => number.toFixed(4).replace(/\.?0+$/, '');
        return `${format(first)}x${format(second)}m`;
      }
    );
    const allowedCollections = (section.dataset.allowedCollections || '')
      .split(',')
      .map(normalize)
      .filter(Boolean);

    const classifyAccessory = (title) => {
      const source = normalize(title);
      if (source.includes('saddlebag') || source.includes('saddle bag')) return 'saddlebag';
      if (source.includes('cushion') || source.includes('pillow')) return 'cushion';
      if (source.includes('collectible') || source.includes('handicraft') || source.includes('object')) return 'collectible-handicrafts';
      return 'other';
    };

    // Shopify collection membership is authoritative. Legacy tags must not
    // silently restore a collection an editor has deliberately removed.
    const classifyCollections = (handles) => {
      const collectionMap = [
        ['antique', 'Antique', 'rugs / antique'],
        ['classic', 'Classic', 'rugs / classic collection'],
        ['tribal-village', 'Tribal & Village', 'rugs / tribal & village'],
        ['gabbeh', 'Gabbeh', 'rugs / gabbeh'],
        ['kilim', 'Kilim', 'rugs / kilim'],
        ['contemporary', 'Contemporary', 'rugs / contemporary'],
        ['pictorial', 'Pictorial Rugs', 'rugs / pictorial rugs'],
        ['runners', 'Runner', 'runners'],
        ['vintage', 'Vintage', 'rugs / vintage'],
        ['accessories', 'Woven Accessories', 'accessories']
      ];
      const productHandles = handles.split('|').map(normalize).filter(Boolean);

      return collectionMap
        .filter(([handle]) => productHandles.includes(handle))
        .filter(([handle]) => !allowedCollections.length || allowedCollections.includes(handle))
        .map(([handle, label]) => ({ handle, label }));
    };

    const classify = (title, size) => {
      const source = size || title;
      const match = source.match(/(\d+(?:[.,]\d+)?)\s*(cm|mm|m)?\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm|m)?\b/i);
      if (!match) return 'other';

      const toMetres = (value, unit) => Number(value.replace(',', '.')) / ({ cm: 100, mm: 1000 }[normalize(unit)] || 1);
      const values = [toMetres(match[1], match[2] || match[4]), toMetres(match[3], match[4] || match[2])].sort((a, b) => a - b);
      if (values.some((value) => !Number.isFinite(value) || value <= 0)) return 'other';
      if (section.dataset.collectionHandle === 'runners') {
        const runnerLength = values[1];
        if (runnerLength >= 4.75) return '5 m+';
        if (runnerLength < 2.5) return '< 2 m';
        return runnerLength >= 3.5 ? '4 m' : '3 m';
      }

      let best = null;

      targets.forEach((target) => {
        const standard = [target.width, target.height].sort((a, b) => a - b);
        const diff = Math.abs(values[0] - standard[0]) + Math.abs(values[1] - standard[1]);
        if (!best || diff < best.diff) best = { label: target.label, diff };
      });

      return best && best.diff <= 0.9 ? best.label : 'other';
    };

    cards.forEach((card) => {
      card.dataset.sizeCategory = classify(card.dataset.productTitle || '', card.dataset.productSize || '');
      card.dataset.productAccessory = classifyAccessory(card.dataset.productTitle || '');
      card.productCollections = classifyCollections(card.dataset.productCollections || '');
    });

    const populateSelect = (select) => {
      const key = select.dataset.filterSelect;
      const values = key === 'collection'
        ? [...new Set(cards.flatMap((card) => card.productCollections.map(({ label }) => label)))].sort((a, b) => a.localeCompare(b))
        : [...new Set(cards.map((card) => (card.dataset[`product${key.charAt(0).toUpperCase()}${key.slice(1)}`] || '').trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));

      values.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    };

    const setQueryParam = (params, key, value) => {
      if (!value || (key !== 'q' && value === 'all')) {
        params.delete(key);
        return;
      }

      params.set(key, value);
    };

    const updateUrl = () => {
      const url = new URL(window.location.href);
      setQueryParam(url.searchParams, 'size', activeFilters.size);
      setQueryParam(url.searchParams, 'accessory', activeFilters.accessory);
      setQueryParam(url.searchParams, 'collection', activeFilters.collection);
      setQueryParam(url.searchParams, 'q', activeFilters.search);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const syncControls = (options = {}) => {
      sizeChips.forEach((chip) => chip.classList.toggle('is-active', chip.dataset.sizeFilter === activeFilters.size));
      accessoryChips.forEach((chip) => chip.classList.toggle('is-active', chip.dataset.accessoryFilter === activeFilters.accessory));
      selects.forEach((select) => {
        select.value = activeFilters[select.dataset.filterSelect] || 'all';
      });
      if (searchInput && options.syncSearch !== false) searchInput.value = activeFilters.search;
    };

    const applyFilters = (options = {}) => {
      syncControls(options);
      let shown = 0;
      cards.forEach((card) => {
        const visible =
          (activeFilters.size === 'all' || card.dataset.sizeCategory === activeFilters.size) &&
          (activeFilters.accessory === 'all' || card.dataset.productAccessory === activeFilters.accessory) &&
          (activeFilters.collection === 'all' || card.productCollections.some(({ label }) => normalize(label) === normalize(activeFilters.collection))) &&
          (!activeFilters.search || normalizeSearchText(card.dataset.productSearch).includes(normalizeSearchText(activeFilters.search)));

        card.classList.toggle('is-hidden', !visible);
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      if (visibleCount) {
        const hasActiveFilter = Object.entries(activeFilters).some(([key, value]) => key === 'search' ? Boolean(value) : value !== 'all');
        visibleCount.textContent = hasActiveFilter ? `${shown} matching pieces` : `${visibleCount.dataset.totalCount} pieces`;
      }

      if (options.updateUrl) updateUrl();
    };

    selects.forEach((select) => {
      populateSelect(select);
      select.addEventListener('change', () => {
          activeFilters[select.dataset.filterSelect] = select.value || 'all';
        applyFilters({ updateUrl: true });
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        activeFilters.search = searchInput.value.trim();
        applyFilters({ updateUrl: true, syncSearch: false });
      });
    }

    sizeChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        activeFilters.size = chip.dataset.sizeFilter || 'all';
        applyFilters({ updateUrl: true });
      });
    });

    accessoryChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        activeFilters.accessory = chip.dataset.accessoryFilter || 'all';
        applyFilters({ updateUrl: true });
      });
    });

    const queryParams = new URLSearchParams(window.location.search);
    const requestedSearch = queryParams.get('q');
    if (requestedSearch) activeFilters.search = requestedSearch;

    const requestedSize = queryParams.get('size');
    if (requestedSize && sizeChips.some((chip) => normalize(chip.dataset.sizeFilter) === normalize(requestedSize))) {
      const matchingChip = sizeChips.find((chip) => normalize(chip.dataset.sizeFilter) === normalize(requestedSize));
      activeFilters.size = matchingChip.dataset.sizeFilter;
    }

    const requestedAccessory = queryParams.get('accessory');
    if (requestedAccessory && accessoryChips.some((chip) => normalize(chip.dataset.accessoryFilter) === normalize(requestedAccessory))) {
      const matchingChip = accessoryChips.find((chip) => normalize(chip.dataset.accessoryFilter) === normalize(requestedAccessory));
      activeFilters.accessory = matchingChip.dataset.accessoryFilter;
    }

    selects.forEach((select) => {
      const key = select.dataset.filterSelect;
      const requestedValue = queryParams.get(key);
      const matchingOption = [...select.options].find((option) => normalize(option.value) === normalize(requestedValue));
      if (matchingOption) activeFilters[key] = matchingOption.value;
    });

    applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
      if (!container.dataset.url || container.dataset.loaded === 'true') return;
      container.dataset.loaded = 'true';

      fetch(container.dataset.url)
        .then((response) => response.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const replacement = parsed.querySelector('[data-product-recommendations]');
          if (replacement && !replacement.classList.contains('is-empty')) {
            container.replaceWith(replacement);
          }
        })
        .catch(() => {
          container.classList.add('is-empty');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.luxury-product').forEach((section) => {
      const mainImage = section.querySelector('[data-product-main-image] img');
      const mainImageButton = section.querySelector('[data-product-main-image]');
      const thumbs = [...section.querySelectorAll('[data-product-thumb]')];
      const lightbox = section.querySelector('[data-product-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
      const lightboxViewport = lightbox?.querySelector('[data-lightbox-viewport]');
      const lightboxCount = lightbox?.querySelector('[data-lightbox-count]');
      const closeButton = lightbox?.querySelector('[data-lightbox-close]');
      const previousButton = lightbox?.querySelector('[data-lightbox-previous]');
      const nextButton = lightbox?.querySelector('[data-lightbox-next]');
      const zoomInButton = lightbox?.querySelector('[data-lightbox-zoom-in]');
      const zoomOutButton = lightbox?.querySelector('[data-lightbox-zoom-out]');
      const zoomResetButton = lightbox?.querySelector('[data-lightbox-zoom-reset]');
      const zoomLevel = lightbox?.querySelector('[data-lightbox-zoom-level]');
      if (!mainImage) return;

      const galleryItems = thumbs.length
        ? thumbs.map((thumb) => ({
            src: thumb.dataset.fullSrc,
            srcset: thumb.dataset.srcset,
            alt: thumb.dataset.alt
          }))
        : [{
            src: mainImageButton?.dataset.fullSrc || mainImage.src,
            srcset: mainImage.srcset,
            alt: mainImageButton?.dataset.alt || mainImage.alt
          }];
      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      let zoom = 1;
      let panX = 0;
      let panY = 0;
      let dragStart = null;

      const renderZoom = () => {
        if (!lightboxImage || !lightboxViewport) return;
        lightboxImage.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
        lightboxViewport.classList.toggle('is-zoomed', zoom > 1);
        if (zoomLevel) zoomLevel.textContent = `${Math.round(zoom * 100)}%`;
        if (zoomOutButton) zoomOutButton.disabled = zoom <= 1;
        if (zoomInButton) zoomInButton.disabled = zoom >= 6;
      };

      const resetZoom = () => {
        zoom = 1;
        panX = 0;
        panY = 0;
        dragStart = null;
        lightboxViewport?.classList.remove('is-dragging');
        renderZoom();
      };

      const setZoom = (nextZoom) => {
        zoom = Math.min(6, Math.max(1, nextZoom));
        if (zoom === 1) {
          panX = 0;
          panY = 0;
        }
        renderZoom();
      };

      const updateMainImage = (index) => {
        const item = galleryItems[index];
        if (!item) return;

        activeIndex = index;
        if (item.src) mainImage.src = item.src;
        if (item.srcset) mainImage.srcset = item.srcset;
        if (item.alt) mainImage.alt = item.alt;
        if (mainImageButton) {
          mainImageButton.dataset.fullSrc = item.src || '';
          mainImageButton.dataset.alt = item.alt || '';
        }

        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const updateLightbox = () => {
        const item = galleryItems[activeIndex];
        if (!item || !lightboxImage) return;

        resetZoom();
        lightboxImage.src = item.src || '';
        lightboxImage.alt = item.alt || '';
        if (lightboxCount) lightboxCount.textContent = `Image ${activeIndex + 1} of ${galleryItems.length}`;
        const hasMultipleImages = galleryItems.length > 1;
        if (previousButton) previousButton.hidden = !hasMultipleImages;
        if (nextButton) nextButton.hidden = !hasMultipleImages;
      };

      const openLightbox = () => {
        if (!lightbox || typeof lightbox.showModal !== 'function') return;
        updateLightbox();
        lightbox.showModal();
        lightboxViewport?.focus();
      };

      mainImageButton?.addEventListener('click', openLightbox);

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          updateMainImage(thumbs.indexOf(thumb));
        });
      });

      closeButton?.addEventListener('click', () => lightbox.close());
      zoomInButton?.addEventListener('click', () => setZoom(zoom + 0.5));
      zoomOutButton?.addEventListener('click', () => setZoom(zoom - 0.5));
      zoomResetButton?.addEventListener('click', resetZoom);
      lightboxViewport?.addEventListener('wheel', (event) => {
        event.preventDefault();
        setZoom(zoom + (event.deltaY < 0 ? 0.5 : -0.5));
      }, { passive: false });
      lightboxViewport?.addEventListener('pointerdown', (event) => {
        if (zoom <= 1) return;
        dragStart = { pointerId: event.pointerId, x: event.clientX - panX, y: event.clientY - panY };
        lightboxViewport.setPointerCapture(event.pointerId);
        lightboxViewport.classList.add('is-dragging');
      });
      lightboxViewport?.addEventListener('pointermove', (event) => {
        if (!dragStart || dragStart.pointerId !== event.pointerId) return;
        panX = event.clientX - dragStart.x;
        panY = event.clientY - dragStart.y;
        renderZoom();
      });
      const stopDragging = (event) => {
        if (!dragStart || dragStart.pointerId !== event.pointerId) return;
        dragStart = null;
        lightboxViewport?.classList.remove('is-dragging');
      };
      lightboxViewport?.addEventListener('pointerup', stopDragging);
      lightboxViewport?.addEventListener('pointercancel', stopDragging);
      previousButton?.addEventListener('click', () => {
        activeIndex = (activeIndex - 1 + galleryItems.length) % galleryItems.length;
        updateMainImage(activeIndex);
        updateLightbox();
      });
      nextButton?.addEventListener('click', () => {
        activeIndex = (activeIndex + 1) % galleryItems.length;
        updateMainImage(activeIndex);
        updateLightbox();
      });
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
      lightbox?.addEventListener('keydown', (event) => {
        if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          setZoom(zoom + 0.5);
        } else if (event.key === '-') {
          event.preventDefault();
          setZoom(zoom - 0.5);
        } else if (event.key === '0') {
          event.preventDefault();
          resetZoom();
        } else if (zoom > 1 && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'ArrowLeft') panX -= 40;
          if (event.key === 'ArrowRight') panX += 40;
          if (event.key === 'ArrowUp') panY -= 40;
          if (event.key === 'ArrowDown') panY += 40;
          renderZoom();
        } else if (event.key === 'ArrowLeft') {
          previousButton?.click();
        } else if (event.key === 'ArrowRight') {
          nextButton?.click();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
